(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["carvex-home"]) return;
  try {
    
    (function(){
      var brand=document.getElementById('carvex-brand'), model=document.getElementById('carvex-model'), find=document.getElementById('carvex-find'), grid=document.getElementById('carvex-brand-grid');
      if(!brand||!model||!find) return;
      function loadModels(){
        var opt=brand.options[brand.selectedIndex];
        model.replaceChildren(new Option(model.dataset.placeholder,''));
        model.disabled=!opt.value;
        find.disabled=true;
        if(grid) grid.querySelectorAll('.carvex-brand').forEach(function(b){b.classList.toggle('is-active',b.dataset.brand===opt.value);});
        if(!opt.value) return;
        var handles=(opt.dataset.modelHandles||'').split(',');
        var names=(opt.dataset.models||'').split(',').filter(Boolean);
        if(!names.length){model.replaceChildren(new Option(brand.dataset.allProducts,'*'));model.disabled=true;find.disabled=false;return;}
        names.forEach(function(name,index){
          var o=new Option(name.trim(),name.trim());
          if(handles[index]) o.dataset.url=brand.dataset.collectionsUrl+'/'+handles[index].trim();
          model.appendChild(o);
        });
        (opt.dataset.legacyModels||'').split(',').filter(Boolean).forEach(function(name){model.appendChild(new Option(name.trim(),name.trim()));});
      }
      brand.addEventListener('change',loadModels);
      model.addEventListener('change',function(){find.disabled=!model.value;});
      find.addEventListener('click',function(){
        var opt=brand.options[brand.selectedIndex], selectedModel=model.options[model.selectedIndex];
        if(!opt.value||!model.value)return;
        if(model.value==='*'){window.location.href=opt.dataset.url;return;}
        if(selectedModel.dataset.url){window.location.href=selectedModel.dataset.url;return;}
        var q=(opt.value+' '+model.value).trim();
        window.location.href=brand.dataset.searchUrl+'?type=product&q='+encodeURIComponent(q);
      });
      loadModels();
    })();
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
